import { Controller } from "@hotwired/stimulus";
import { patch } from "@rails/request.js";
import { Current } from "current.js";
import { ethers } from "ethers";

// Connects to data-controller="jankenpon"
export default class extends Controller {
  static targets = ["rock", "paper", "scissors", "choiceTitle", "choiceImg", "amount", "decide"];

  async connect() {
    const somnia_chain_id = 5031;
    this.is_deciding = false;

    this.provider = new ethers.BrowserProvider(window.ethereum);
    this.signer = await this.provider.getSigner();
    this.jankenpon = await this.#getJankenponContract();

    this.choice = null;
    this.bet_amount = null;

    const network = await this.provider.getNetwork();
    this.is_wrong_chain = network.chainId != somnia_chain_id ? true : false;

    if (this.is_wrong_chain) {
      // toast('Wrong blockchain chain detected', { type: 'error', description: 'Please switch chain to Somnia Mainnet' })
      this.#addSomniaNetwork();
      return;
    }
  }

  selectDecision(event) {
    this.rockTarget.removeAttribute("data-active");
    this.paperTarget.removeAttribute("data-active");
    this.scissorsTarget.removeAttribute("data-active");
    this.choice = null;

    this.choiceTitleTarget.setAttribute("hidden", true);
    this.choiceImgTargets.forEach((el) => el.setAttribute("hidden", true));

    switch (event.params.decision) {
      case "rock":
        this.rockTarget.setAttribute("data-active", true);
        this.choice = "rock";
        this.choiceImgTargets[0].removeAttribute("hidden");
        break;
      case "scissors":
        this.scissorsTarget.setAttribute("data-active", true);
        this.choice = "scissors";
        this.choiceImgTargets[1].removeAttribute("hidden");
        break;
      case "paper":
        this.paperTarget.setAttribute("data-active", true);
        this.choice = "paper";
        this.choiceImgTargets[2].removeAttribute("hidden");
        break;
    }
  }

  selectAmount(event) {
    this.amountTargets.forEach((amount) => amount.removeAttribute("data-active"));
    event.currentTarget.toggleAttribute("data-active");

    this.bet_amount = event.currentTarget.dataset.amount;
  }

  async #getJankenponContract() {
    const abi = [
      {
        inputs: [{ internalType: "uint256", name: "winBP", type: "uint256" }],
        name: "bet",
        outputs: [],
        stateMutability: "payable",
        type: "function",
      },
      {
        anonymous: false,
        inputs: [
          { indexed: false, internalType: "uint256", name: "betId", type: "uint256" },
          { indexed: true, internalType: "address", name: "owner", type: "address" },
          { indexed: false, internalType: "uint256", name: "amount", type: "uint256" },
        ],
        name: "Bet",
        type: "event",
      },
    ];

    return new ethers.Contract(Current.address.jankenpon, abi, this.signer);
  }

  async handleDecide() {
    this.decideTarget.setAttribute("disabled", true);
    showLoading("Thinking...");

    var bet_id = null;

    try {
      const tx = await this.jankenpon.bet(20000, {
        value: ethers.parseEther(this.bet_amount.toString()),
      });

      const receipt = await tx.wait();

      receipt.logs.forEach((log) => {
        if (log.fragment && log.fragment.name === "Bet") {
          bet_id = log.args[0];
        }
      });
    } catch (e) {
      console.log(e);
      this.#resetGameState();
      hideLoading();
      return;
    }

    try {
      await patch("/user/rock-paper-scissors", {
        body: JSON.stringify({
          id: bet_id.toString(),
          amount: this.bet_amount,
          choice: this.choice,
        }),
      });
    } catch (e) {
      console.log(e);
      toast(`Game ${bet_id.toString()} failed`, {
        description: "Server error occured, please notify admin with your game id",
        type: "error",
      });
    }

    this.#resetGameState();
    hideLoading();
  }

  #resetGameState() {
    this.decideTarget.removeAttribute("disabled");

    this.rockTarget.removeAttribute("data-active");
    this.paperTarget.removeAttribute("data-active");
    this.scissorsTarget.removeAttribute("data-active");
    this.choice = null;

    this.choiceImgTargets.forEach((el) => el.setAttribute("hidden", true));
    this.choiceTitleTarget.removeAttribute("hidden");

    this.amountTargets.forEach((amount) => amount.removeAttribute("data-active"));
  }

  async #addSomniaNetwork() {
    showLoading("Switching Network");

    const network = {
      chainId: "0x13a7",
      chainName: "Somnia",
      nativeCurrency: { name: "SOMI", symbol: "SOMI", decimals: 18 },
      rpcUrls: ["https://api.infra.mainnet.somnia.network"],
      blockExplorerUrls: ["https://explorer.somnia.network/"],
    };

    try {
      await window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: network.chainId }],
      });
    } catch (switchError) {
      if (switchError.code === 4902) {
        try {
          await window.ethereum.request({
            method: "wallet_addEthereumChain",
            params: [network],
          });
          hideLoading();
        } catch (addError) {
          toast("User rejected the request to add network", { type: "error" });
          this.#addSomniaNetwork();
        }
      } else {
        toast("Failed to switch network", { type: "error" });
      }
    }
  }
}
